import { makeCancellableAPIRequest } from "./index";

const TeamsAPI = {
  getTeam(id) {
    return makeCancellableAPIRequest(
      "GET",
      `/api/team/${id}`,
    )
  },
  getListing(params) {
    const { filters, ...restParams } = params;
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/filtered-data",
      {
        params: {...restParams, ...filters }
      }
    )
  },
  validate(params) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/name-check",
      {
        params
      }
    )
  },
  saveTeam(data, methodType) {
    return makeCancellableAPIRequest(
      methodType,
      "/api/team",
      {
        data
      }
    )
  },
  saveTeamWithUser(data) {
    return makeCancellableAPIRequest(
      'PUT',
      "/api/team/with-user",
      {
        data
      }
    )
  },
  deleteTeam(id) {
    return makeCancellableAPIRequest(
      "DELETE",
      "/api/team/" + id
    )
  },
  getAllTeams(params) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/all-teams",
      {
        params
      }
    )
  },
  getUserTeams(params) {
    return makeCancellableAPIRequest(
      "GET",
      "/user/get-teams",
      {
        params
      }
    )
  },
  getTeamsFilter() {
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/filters"
    )
  },
  getUsersFromTeam(id) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/" + id
    )
  },
  getAssociatedProductsAndSubProducts(id) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/associated-product-sub-product/" + id
    )
  },
  getAllTeamsStats(params) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/all-team-stats",
      {
        params
      }
    )
  },
  getTeamRemediationStats(data) {
    return makeCancellableAPIRequest(
      "POST",
      "/api/finding-sla/team-remediation-stats",
      {
        data
      }
    ) 
  },
  getTeamSlaStats(data) {
    return makeCancellableAPIRequest(
      "POST",
      "/user/findingSla/team-sla-stats",
      {
        data
      }
    ) 
  },
  getApprovers(params) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/available-reviewers",
      {
        params
      }
    )
  },
  getProductSubProductTeams(params) {
    return makeCancellableAPIRequest(
      "GET",
      "/api/team/having-product-access",
      {
        params
      }
    )
  },
  getAccessibleTeams(data) {
    return makeCancellableAPIRequest(
      "POST",
      "/api/team/accessible",
      {
        data
      }
    )
  },
};

export default TeamsAPI;
